import _filter from 'lodash/filter'
import moment from 'moment'

export default {
  getters: {
    Notifications: (state, getters) => {
      if (getters.currentTripDashboardId) {
        let notifications = getters.Trips[getters.currentTripDashboardId].notifications
        if (!getters.isOperator) {
          let countItems = _filter(getters.incompleteTodoItems, function (i) {
            return moment().diff(i.actual_due_date) >= 0
          }).length

          if (countItems > 0) {
            notifications.push({
              message: `You have ${countItems} todo items to complete.`,
              route: {
                name: 'to-do.incomplete'
              }
            })
          }
        }

        return notifications
      } else {
        return []
      }
    }
  }
}
